import { z } from 'zod';
import { idSchema, isoDateSchema, isoDateTimeSchema, isoTimeSchema } from './common.js';
export const taskStatusSchema = z.enum(['pending', 'done']);
export const taskInputSchema = z.object({
    event_id: idSchema.nullable(),
    brand_id: idSchema.default(1),
    title: z.string().min(1).max(200),
    responsible_id: idSchema,
    due_date: isoDateSchema,
    due_time: isoTimeSchema.nullable(),
    description: z.string().max(2000).nullable(),
    status: taskStatusSchema.default('pending'),
});
export const taskSchema = taskInputSchema.extend({
    id: idSchema,
    done_at: isoDateTimeSchema.nullable(),
    created_by: idSchema,
    updated_by: idSchema,
    created_at: isoDateTimeSchema,
    updated_at: isoDateTimeSchema,
});
//# sourceMappingURL=task.js.map